import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState } from '../../../types/types';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';
import { IAuthUser } from '../../../store/model/authUser/types';
import { authUserPatch } from './api/helper/authUserPatch';
import { IOneTimePoll } from '../../../types/rest/IUserMeta';
import { DEFAULT_POLL } from '../../../const';

export const authUserSetRateKanbanPoll = (
    rateKanbanPoll: Partial<IOneTimePoll>,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const authUser = getAuthUser(getState());
        const rateKanbanPollCurrent = authUser.meta && authUser.meta.rateKanbanPoll || DEFAULT_POLL;
        const userPatch: IAuthUser = {
            id: authUser.id,
            meta: {
                rateKanbanPoll: { ...rateKanbanPollCurrent, ...rateKanbanPoll },
            }
        };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
